import { FragmentComponent } from '@/types/graphql'
import { DSLinkButton } from '@/components/ds/LinkButton/LinkButton'
import { DSSpacer, DSText } from '@zoe/ds-web'
import { TrackingContext } from '@/context/trackingContext'
import { trackCtaClick } from '@/lib/gtm/gtmV2'
import React, { useContext } from 'react'
import { ctaCollectionBlock } from '@/lib/api/graphql/utils/commonBlocks'

export type CtaRecord = {
  __typename: 'CtaRecord'
  id: string
  label: string
  url: string
  newTab?: boolean
  variant?: 'primary' | 'secondary' | 'tertiary' | 'google_play' | 'app_store'
  noWrap?: boolean
}

export type CtaCollectionRecord = CtaRecord[]

const Cta = ({ record }: { record: CtaRecord }) => {
  const { section } = useContext(TrackingContext)
  const handleOnPress = ({ label }) => {
    trackCtaClick(section || 'cms', label || '')
  }
  const noWrapStyle = record.noWrap ? { whiteSpace: 'nowrap' } : {}

  if (record.variant === 'app_store') {
    return (
      <a
        href={record.url || 'https://apps.apple.com/us/app/zoe-insights/id1471632228'}
        target={record.newTab ? '_blank' : '_self'}
        rel="noopener noreferrer"
        onClick={() => handleOnPress({ label: record.label || 'App Store Download' })}
      >
        <img
          src="/assets/img/app/AppStore.png"
          alt={record.label || 'Download on the App Store'}
          style={{ display: 'block', width: '166px', marginBottom: '16px' }}
        />
      </a>
    )
  }
  if (record.variant === 'google_play') {
    return (
      <a
        href={record.url || 'https://play.google.com/store/apps/details?id=com.joinzoe.results'}
        target={record.newTab ? '_blank' : '_self'}
        rel="noopener noreferrer"
        onClick={() => handleOnPress({ label: record.label || 'Google Play Download' })}
      >
        <img
          src="/assets/img/app/PlayStore.png"
          alt={record.label || 'Get it on Google Play'}
          style={{ display: 'block', width: '166px', marginBottom: '16px' }}
        />
      </a>
    )
  }
  if (record.variant === 'primary' || record.variant === 'secondary' || record.variant === 'tertiary') {
    return (
      <DSLinkButton
        variant={record.variant || 'primary'}
        colourScheme="default"
        size="large"
        width="auto"
        href={record.url}
        target={record.newTab ? '_blank' : '_self'}
        onPress={() => handleOnPress({ label: record.label })}
      >
        <DSSpacer direction="horizontal" size={32} />
        <DSText as="span" variant="fluid-paragraph-200" weight="semiBold" style={noWrapStyle}>
          {record.label}
        </DSText>
        <DSSpacer direction="horizontal" size={32} />
      </DSLinkButton>
    )
  }
}

export const CtaCollectionBlock: FragmentComponent<{}, CtaCollectionRecord> = ({ record }) => {
  return [...record].map((item) => (
    <>
      <Cta key={item.id} record={item} />
      <DSSpacer direction="horizontal" size={16} />
    </>
  ))
}

CtaCollectionBlock.fragment = ctaCollectionBlock
CtaCollectionBlock.recordName = 'CtaCollectionRecord'
